var _defs, _rect, _polygon, _path, _path2, _path3, _path4, _path5, _rect2, _rect3, _rect4, _rect5, _rect6, _polygon2, _polygon3, _polygon4, _polygon5, _path6, _path7, _path8, _path9, _path10, _rect7, _rect8, _rect9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMonitor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "_1-App",
    "data-name": "1-App",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#979faf;}.cls-2{fill:#adb2c7;}.cls-3{fill:#8dd5f6;}.cls-4{fill:#dfe1ea;}.cls-5{fill:#aedff7;}.cls-6{fill:#f6fafd;}.cls-7{fill:#7e8596;}.cls-8{fill:#0096cf;}.cls-9{fill:#fff;}.cls-10{fill:#73c6b2;}.cls-11{fill:#e9edf5;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1-App") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 19,
    y: 59,
    width: 26,
    height: 3
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "40 50 45 59 19 59 24 50 40 50"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M63,4V42H1V4A2.006,2.006,0,0,1,3,2H61A2.006,2.006,0,0,1,63,4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M63,42v6a2.006,2.006,0,0,1-2,2H3a2.006,2.006,0,0,1-2-2V42Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M61,2H3A2.006,2.006,0,0,0,1,4V18.844A26.743,26.743,0,0,0,9.2,20c7.6,0,7.6-2,15.2-2s7.6,2,15.2,2,7.6-2,15.2-2A26.787,26.787,0,0,1,63,19.157V4A2.006,2.006,0,0,0,61,2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M61,2H3A2.006,2.006,0,0,0,1,4v7.844A26.743,26.743,0,0,0,9.2,13c7.6,0,7.6-2,15.2-2s7.6,2,15.2,2,7.6-2,15.2-2A26.787,26.787,0,0,1,63,12.157V4A2.006,2.006,0,0,0,61,2Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M24,50l-1.832,3.3A25.289,25.289,0,0,0,28.6,54c6.6,0,7.475-1.507,12.57-1.9L40,50Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 42,
    y: 20,
    width: 20,
    height: 22,
    rx: 0.99,
    ry: 0.99
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 7,
    y: 22,
    width: 15,
    height: 15,
    rx: 0.99,
    ry: 0.99
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 19,
    y: 8,
    width: 17,
    height: 15,
    rx: 0.99,
    ry: 0.99
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 39,
    y: 24,
    width: 20,
    height: 14
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 39,
    y: 16,
    width: 20,
    height: 8
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "32.5 7 19 20 19 6 33 6 33 7 32.5 7"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "33 6 33 20 18.481 20 32.481 6 33 6"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "19 20 19 34 4.481 34 18.481 20 19 20"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "19 20 19 21 18.5 21 5 34 5 20 19 20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61,1H3A3,3,0,0,0,0,4V48a3,3,0,0,0,3,3H22.3l-4.175,7.514A1,1,0,0,0,18,59v2H16v2H48V61H46V59a1,1,0,0,0-.126-.486L41.7,51H61a3,3,0,0,0,3-3V4A3,3,0,0,0,61,1ZM3,3H61a1,1,0,0,1,1,1V41H2V4A1,1,0,0,1,3,3ZM20,61V60H44v1Zm23.3-3H20.7l3.888-7H39.412ZM61,49H3a1,1,0,0,1-1-1V43H62v5A1,1,0,0,1,61,49Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5,35H19a1,1,0,0,0,1-1V21H33a1,1,0,0,0,1-1V6a1,1,0,0,0-1-1H19a1,1,0,0,0-1,1V19H5a1,1,0,0,0-1,1V34A1,1,0,0,0,5,35Zm2.414-2L18,22.414V33Zm14-14L32,8.414V19ZM30.586,7,20,17.586V7Zm-14,14L6,31.586V21Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39,39H59a1,1,0,0,0,1-1V16a1,1,0,0,0-1-1H39a1,1,0,0,0-1,1V38A1,1,0,0,0,39,39Zm1-2V25H58V37ZM58,17v6H40V17Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.707,31.293l-1.414,1.414L30.586,34H24v2h6.586l-1.293,1.293,1.414,1.414,3-3a1,1,0,0,0,0-1.414Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.707,22.293l-1.414,1.414L30.586,25H24v2h6.586l-1.293,1.293,1.414,1.414,3-3a1,1,0,0,0,0-1.414Z"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 42,
    y: 19,
    width: 2,
    height: 2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 46,
    y: 19,
    width: 2,
    height: 2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 42,
    y: 27,
    width: 14,
    height: 8
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/monitor.01a7cb102edad6b0f59d03a9a10d517b.svg";
export { ForwardRef as ReactComponent };